import React, { useState } from "react";
import "./FleetCoreProductFilmOverview.css";

import fleetcoreProductFilmOverviewOperationalPoster from "../../images/fleetcore-mine-bakkie-dashboard-inspection.jpg";
import fleetcoreProductFilmOverviewPlayControl from "../../images/fleetcore-product-film-overview-play-control.svg";
import fleetcoreProductFilmOverviewEvidenceRail from "../../images/fleetcore-product-film-overview-evidence-rail.svg";

const FLEETCORE_YOUTUBE_ID = "8w-6dlLaNBs";
const FLEETCORE_YOUTUBE_EMBED_URL = `https://www.youtube.com/embed/${FLEETCORE_YOUTUBE_ID}?autoplay=1&rel=0&modestbranding=1`;

export default function FleetCoreProductFilmOverview({ onPlay }) {
  const [videoHasStarted, setVideoHasStarted] = useState(false);

  const handleFleetCoreVideoPlay = () => {
    setVideoHasStarted(true);
    if (typeof onPlay === "function") {
      onPlay();
    }
  };

  return (
    <section
      className="fleetcore-product-film-overview"
      id="fleetcore-overview"
      aria-labelledby="fleetcore-product-film-overview-title"
    >
      <div className="fleetcore-product-film-overview__inner">
        <div className="fleetcore-product-film-overview__copy">
          <p className="fleetcore-product-film-overview__eyebrow">
            FLEETCORE IN OPERATION
          </p>
          <h2 id="fleetcore-product-film-overview-title">
            See the complete accountability loop in action.
          </h2>
          <p className="fleetcore-product-film-overview__body">
            Follow one fleet event from verified driver to recorded fuel and
            management insight—without losing the evidence between systems.
          </p>
          <p className="fleetcore-product-film-overview__statement">
            DRIVER · VEHICLE · FUEL · INSIGHT
          </p>
        </div>
        <div
          className={`fleetcore-product-film-overview__media${
            videoHasStarted
              ? " fleetcore-product-film-overview__media--started"
              : ""
          }`}
        >
          {videoHasStarted ? (
            <iframe
              className="fleetcore-product-film-overview__video fleetcore-product-film-overview__video--youtube"
              src={FLEETCORE_YOUTUBE_EMBED_URL}
              title="FleetCore product overview"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              referrerPolicy="strict-origin-when-cross-origin"
            />
          ) : (
            <>
              <img
                className="fleetcore-product-film-overview__poster"
                src={fleetcoreProductFilmOverviewOperationalPoster}
                alt="Fleet driver capturing vehicle and refuelling evidence at a commercial fleet depot"
              />
              <button
                className="fleetcore-product-film-overview__play"
                type="button"
                onClick={handleFleetCoreVideoPlay}
                aria-label="Play FleetCore product overview"
              >
                <img
                  src={fleetcoreProductFilmOverviewPlayControl}
                  alt=""
                  aria-hidden="true"
                />
              </button>
            </>
          )}
          {!videoHasStarted ? (
            <img
              className="fleetcore-product-film-overview__rail"
              src={fleetcoreProductFilmOverviewEvidenceRail}
              alt="Driver verified, vehicle linked and fuel event recorded"
            />
          ) : null}
        </div>
      </div>
    </section>
  );
}
